import { render, staticRenderFns } from "./CandidatesChangeCourseBulk.vue?vue&type=template&id=0c3d2f4d&lang=pug"
import script from "./CandidatesChangeCourseBulk.vue?vue&type=script&lang=js"
export * from "./CandidatesChangeCourseBulk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports